import { IMAGE_SERVER_URL } from '../common/apiConfig';
/**
 * API에서 제공받은 이미지 URL을 알맞은 크기의 webp로 변환하여 요청합니다.
 *
 * @param imageUrl
 * @param width
 */
var convertImageUrl = function (imageUrl, width) {
    var convertedImageUrl = imageUrl;
    if (!convertedImageUrl) {
        return '';
    }
    // root slash 시작 케이스 처리
    if (!convertedImageUrl.startsWith('http')) {
        convertedImageUrl = IMAGE_SERVER_URL + imageUrl;
    }
    if (convertedImageUrl.startsWith('http://')) {
        // mixed content 에러 방지
        convertedImageUrl = convertedImageUrl.replace('http://', 'https://');
    }
    // 요청 주소가 tving 이미지 서버이나, webp 변환 요청이 아닐 경우
    if (convertedImageUrl.match(/https.*image.*.tving.com/g) && !convertedImageUrl.includes('/dims/resize/F_webp')) {
        convertedImageUrl += "/dims/resize/F_webp".concat(width ? ",".concat(width) : '');
    }
    else if (convertedImageUrl.includes('/dims/resize/F_webp') && !convertedImageUrl.includes('/dims/resize/F_webp,') && width) {
        // 이미 webp 로 변환된 url에 추가로 width 변환을 요청하는 경우 (ex. gnb 사용자 아이콘 , setting 사용자 정보)
        convertedImageUrl += ",".concat(width);
    }
    return convertedImageUrl;
};
export default convertImageUrl;
